import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const Layout = ({
  children
}) => {
  return <div className="flex flex-col min-h-screen" data-id="element-39">
      <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-40">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-41">
          <Link to="/" className="flex-shrink-0" data-id="element-42">
            <Logo data-id="element-43" />
          </Link>
          <nav className="hidden lg:flex space-x-6" data-id="element-44">
            <Link to="/" className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-45">
              Home
            </Link>
            <Link to="/service-coverage" className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-46">
              Service Coverage
            </Link>
            <Link to="/about-us" className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-47">
              About Us
            </Link>
            <Link to="/contact-us" className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-48">
              Contact Us
            </Link>
            <Link to="/faq" className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-49">
              FAQs
            </Link>
            <div className="group relative" data-id="element-50">
              <button className="text-[#E57C23] hover:text-[#F8B179] transition-colors" data-id="element-51">
                Policies
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50" data-id="element-52">
                <Link to="/cancellation-policy" className="block px-4 py-2 text-sm text-[#E57C23] hover:bg-[#FFF8F0]" data-id="element-53">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block px-4 py-2 text-sm text-[#E57C23] hover:bg-[#FFF8F0]" data-id="element-54">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block px-4 py-2 text-sm text-[#E57C23] hover:bg-[#FFF8F0]" data-id="element-55">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms-conditions" className="block px-4 py-2 text-sm text-[#E57C23] hover:bg-[#FFF8F0]" data-id="element-56">
                  Terms & Conditions
                </Link>
              </div>
            </div>
          </nav>
          <div className="hidden md:flex items-center" data-id="element-57">
            <a href="mailto:bijayathakur8098@gmail.com" className="flex items-center text-[#E57C23] font-medium" data-id="element-58">
              <MailIcon className="w-5 h-5 mr-2" data-id="element-59" />
              bijayathakur8098@gmail.com
            </a>
          </div>
          <button className="lg:hidden" data-id="element-60">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#E57C23]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-61">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-62" />
            </svg>
          </button>
        </div>
      </header>
      <main className="flex-grow bg-[#FFF8F0]" data-id="element-63">{children}</main>
      <footer className="bg-[#E57C23] text-white" data-id="element-64">
        <div className="container mx-auto px-4 py-12" data-id="element-65">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-66">
            <div data-id="element-67">
              <h3 className="text-xl font-bold mb-4" data-id="element-68">About Realmpoint</h3>
              <p className="mb-4" data-id="element-69">
                We specialise in fast, reliable appliance repairs across the UK.
                Our expert engineers provide quality service with transparent
                pricing.
              </p>
              <div className="flex items-center mb-2" data-id="element-70">
                <MapPinIcon className="w-5 h-5 mr-2 text-[#FFD28F]" data-id="element-71" />
                <span data-id="element-72">19 Clayton St, Newcastle upon Tyne NE1 5PY</span>
              </div>
              <div className="flex items-center mb-2" data-id="element-73">
                <PhoneIcon className="w-5 h-5 mr-2 text-[#FFD28F]" data-id="element-74" />
                <span data-id="element-75">0800 055 4969</span>
              </div>
              <div className="flex items-center" data-id="element-76">
                <MailIcon className="w-5 h-5 mr-2 text-[#FFD28F]" data-id="element-77" />
                <span data-id="element-78">bijayathakur8098@gmail.com</span>
              </div>
            </div>
            <div data-id="element-79">
              <h3 className="text-xl font-bold mb-4" data-id="element-80">Quick Links</h3>
              <ul className="space-y-2" data-id="element-81">
                <li data-id="element-82">
                  <Link to="/" className="hover:text-[#FFD28F] transition-colors" data-id="element-83">
                    Home
                  </Link>
                </li>
                <li data-id="element-84">
                  <Link to="/service-coverage" className="hover:text-[#FFD28F] transition-colors" data-id="element-85">
                    Service Coverage
                  </Link>
                </li>
                <li data-id="element-86">
                  <Link to="/about-us" className="hover:text-[#FFD28F] transition-colors" data-id="element-87">
                    About Us
                  </Link>
                </li>
                <li data-id="element-88">
                  <Link to="/contact-us" className="hover:text-[#FFD28F] transition-colors" data-id="element-89">
                    Contact Us
                  </Link>
                </li>
                <li data-id="element-90">
                  <Link to="/faq" className="hover:text-[#FFD28F] transition-colors" data-id="element-91">
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-92">
              <h3 className="text-xl font-bold mb-4" data-id="element-93">Policies</h3>
              <ul className="space-y-2" data-id="element-94">
                <li data-id="element-95">
                  <Link to="/cancellation-policy" className="hover:text-[#FFD28F] transition-colors" data-id="element-96">
                    Cancellation Policy
                  </Link>
                </li>
                <li data-id="element-97">
                  <Link to="/refund-policy" className="hover:text-[#FFD28F] transition-colors" data-id="element-98">
                    Refund Policy
                  </Link>
                </li>
                <li data-id="element-99">
                  <Link to="/privacy-policy" className="hover:text-[#FFD28F] transition-colors" data-id="element-100">
                    Privacy & Cookie Policy
                  </Link>
                </li>
                <li data-id="element-101">
                  <Link to="/terms-conditions" className="hover:text-[#FFD28F] transition-colors" data-id="element-102">
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-103">
              <h3 className="text-xl font-bold mb-4" data-id="element-104">Opening Hours</h3>
              <ul className="space-y-2" data-id="element-105">
                <li className="flex items-center" data-id="element-106">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-107" />
                  <span data-id="element-108">Monday: 9:00am – 5:00pm</span>
                </li>
                <li className="flex items-center" data-id="element-109">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-110" />
                  <span data-id="element-111">Tuesday: 9:00am – 5:00pm</span>
                </li>
                <li className="flex items-center" data-id="element-112">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-113" />
                  <span data-id="element-114">Wednesday: 9:00am – 5:00pm</span>
                </li>
                <li className="flex items-center" data-id="element-115">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-116" />
                  <span data-id="element-117">Thursday: 9:00am – 5:00pm</span>
                </li>
                <li className="flex items-center" data-id="element-118">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-119" />
                  <span data-id="element-120">Friday: 9:00am – 5:00pm</span>
                </li>
                <li className="flex items-center" data-id="element-121">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-122" />
                  <span data-id="element-123">Saturday: Closed</span>
                </li>
                <li className="flex items-center" data-id="element-124">
                  <ClockIcon className="w-4 h-4 mr-2 text-[#FFD28F]" data-id="element-125" />
                  <span data-id="element-126">Sunday: Closed</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 text-center text-sm" data-id="element-127">
            <p data-id="element-128">
              &copy; {new Date().getFullYear()} Realmpoint. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
};
export default Layout;